import {getFormattedPrice} from "../utils/get-formatted-price";
import {isEmptyObject} from "../utils/is-empty-object";
import {getGroupItemsMarkup} from "../../js/utils/markup/get-group-item-markup";
import AbstractComponent from "./abstract-component";

const getOptionsMarkup = (options) => {
  return Object.keys(options)
    .map((optionId) => {
      const option = options[optionId];

      return (
        `<li class="cart-page__servicesItem">
          <label class="cart-page__servicesCheckbox checkbox">
            <input class="checkbox__input" type="checkbox" value="" data-id="${optionId}" ${option.used ? `checked` : ``}>
            <span class="checkbox__label">${option.title}</span>
          </label>
          <p class="cart-page__servicesPrice price">${getFormattedPrice(option.price)}</p>
        </li>`
      );
    }).join(`\n`);
};


const createTemplate = (cityP, data, isShowOptions, isShowGifts) => {
  const {itemId, isActive, title, link, imgSrc, deliveryDate, stockCount, count, oldPrice, oldPriceSum, price, priceSum, gifts, options} = data;

  return (
    `<section class="cart-page__itemWrap" data-is-active="${isActive}">
      <h2 class="cart-page__itemTitle">
        <a class="" href="${link}" target="_blank">${title}</a>
      </h2>
      <p class="cart-page__itemId">Код товара: ${itemId}</p>
      <img class="cart-page__itemImage" src="${imgSrc}" alt="${title}">

      ${isActive
      ? `<div class="cart-page__storeWrap">
          <p class="cart-page__itemDate">Склад, поступление ${deliveryDate}</p>
          ${+stockCount
      ? `<p class="cart-page__itemStore">В наличии в ${cityP}, ${stockCount} шт.</p>`
      : ``}
        </div>

        <div class="cart-page__counterWrap">
        </div>
        
        ${oldPrice
      ? `<p class="cart-page__oldPrice price">${count === 1 ? getFormattedPrice(oldPrice) : getFormattedPrice(oldPriceSum)}</p>`
      : ``}

        <p class="cart-page__price price">${count === 1 ? getFormattedPrice(price) : getFormattedPrice(priceSum)}</p>`
      : `<p class="cart-page__notAvailable">Нет в наличии</p>`}

      <button type="button" class="cart-page__deleteButton" title="Удалить">
        Удалить
        <svg class="" width="24" height="24" aria-hidden="true">
          <use href="sienge/img/sprite.svg#icon-trash"></use>
        </svg>
      </button>

      ${gifts && !isEmptyObject(gifts.groups)
      ? `<div class="cart-page__giftsWrap" data-show="${isShowGifts}">
          <button class="cart-page__openGiftsButton" type="button">
            ${gifts.title}
            <svg class="" width="10" height="10" aria-hidden="true">
              <use href="sienge/img/sprite.svg#arrow-small"></use>
            </svg>
            <span class="cart-page__countGifts">${Object.keys(gifts.groups).length}</span>
          </button>
          
          <ul class="group-page__groupList" data-size="medium">
            ${getGroupItemsMarkup(gifts.groups)}
          </ul>
        </div>`
      : ``}

      ${options && !isEmptyObject(options) && isActive
      ? `<div class="cart-page__servicesWrap" data-show="${isShowOptions}">
          <button class="cart-page__openServicesButton" type="button">
            Дополнительные услуги
            <svg class="" width="10" height="10" aria-hidden="true">
              <use href="sienge/img/sprite.svg#arrow-small"></use>
            </svg>
            <span class="cart-page__countServices">${Object.keys(options).length}</span>
          </button>

          <div class="cart-page__services">
            <ul class="cart-page__servicesList">
              ${getOptionsMarkup(options)}
            </ul>
          </div>
        </div>`
      : ``}
    </section>`
  );
};


export default class ProductCartComponent extends AbstractComponent {
  constructor({cityP = ``, data = ``, isShowOptions}) {
    super();

    this._cityP = cityP;
    this._data = data;

    // this._isShowOptions = isShowOptions;
    this._isShowOptions = document.documentElement.clientWidth > 1000;
    this._isShowGifts = document.documentElement.clientWidth > 1000;
    // this._setExpandOptionsButtonClickHandler();
  }

  getTemplate() {
    return createTemplate(this._cityP, this._data, this._isShowOptions, this._isShowGifts);
  }

  setDeleteButtonClickHandler(handler) {
    if (!this.getElement().querySelector(`.cart-page__deleteButton`)) {
      return;
    }

    this.getElement().querySelector(`.cart-page__deleteButton`)
    .addEventListener(`click`, handler);
  }

  setOptionChangeHandler(handler) {
    const checkboxes = this.getElement().querySelectorAll(`.checkbox__input`);

    Array.from(checkboxes).forEach((checkbox) => {
      checkbox.addEventListener(`change`, () => {
        const action = checkbox.checked ? `add` : `delete`;
        handler(checkbox.dataset.id, action);
      });
    });
  }

  setExpandOptionsButtonClickHandler(handler) {
    const button = this.getElement().querySelector(`.cart-page__openServicesButton`);

    if (!button) {
      return;
    }

    button.addEventListener(`click`, () => {
      this._isShowOptions = !this._isShowOptions;
      this.getElement().querySelector(`.cart-page__servicesWrap`).dataset.show = this._isShowOptions;
      handler(this._isShowOptions);
    });
  }

  setExpandGiftsButtonClickHandler(handler) {
    const button = this.getElement().querySelector(`.cart-page__openGiftsButton`);

    if (!button) {
      return;
    }

    button.addEventListener(`click`, () => {
      this._isShowGifts = !this._isShowGifts;
      this.getElement().querySelector(`.cart-page__giftsWrap`).dataset.show = this._isShowGifts;
      handler(this._isShowGifts);
    });
  }

  // _setExpandOptionsButtonClickHandler() {
  //   const button = this.getElement().querySelector(`.cart-page__openServicesButton`);

  //   if (!button) {
  //     return;
  //   }

  //   button.addEventListener(`click`, () => {
  //     this._isShowOptions = !this._isShowOptions;
  //     this.getElement().querySelector(`.cart-page__servicesWrap`).dataset.show = this._isShowOptions;
  //   });
  // }
}

